import { render, staticRenderFns } from "./FormSeoConfig.vue?vue&type=template&id=043668ce&"
import script from "./FormSeoConfig.vue?vue&type=script&lang=js&"
export * from "./FormSeoConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('043668ce')) {
      api.createRecord('043668ce', component.options)
    } else {
      api.reload('043668ce', component.options)
    }
    module.hot.accept("./FormSeoConfig.vue?vue&type=template&id=043668ce&", function () {
      api.rerender('043668ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/seo-config/form/FormSeoConfig.vue"
export default component.exports